import React, { useEffect, useRef, useState } from 'react';
import {
  string, node, arrayOf, oneOfType, shape, bool
} from 'prop-types';
import deepmerge from 'deepmerge';
import QueryContext from './QueryContext';
import { filterClient } from './dataModel/filterClient';

const walkChildrenTree = (children) => {
  return React.Children.toArray(children).map((child) => {
    if (child.type?.dataModel) {
      return child;
    }
    if (child.props?.children) {
      return walkChildrenTree(child.props.children);
    }
    return null;
  }).flat()
    .filter((val) => val);
};

export const QueryProvider = ({
  dataSource, children, defaultVariables
}) => {

  const defaultVariablesRef = useRef({});
  if (defaultVariables) {
    defaultVariablesRef.current = defaultVariables;
  }

  // get all dataModels of children for client and server
  const childWrapper = walkChildrenTree(children);
  const client = childWrapper.map((child) => {
    return child.type?.dataModel || {};
  }).reduce((acc, cur) => {
    return deepmerge(acc, cur);
  }, {});

  const server = childWrapper.map((child) => {
    return child.type?.dataModel || {};
  }).reduce((acc, cur) => {
    const filtered = filterClient(cur);
    return deepmerge(acc, filtered);
  }, {});

  const queryAttributes = {
    client,
    server
  };

  const value = {
    dataSource,
    queryAttributes,
    defaultVariables: defaultVariablesRef,
  };
  return (
    <QueryContext.Provider value={value}>
      {children}
    </QueryContext.Provider>
  );
};

QueryProvider.propTypes = {
  children: oneOfType([
    node,
    arrayOf(node),
  ]).isRequired,
  defaultVariables: shape({}),
  dataSource: string
};

QueryProvider.defaultProps = {
  dataSource: '',
  defaultVariables: null,
};
